<script>
import BuyNow from './buy-now.vue';
import Edit from "./edit.vue";
import EditDelta from "./edit-delta.vue";
import Add from "./add.vue";
import Upgrade from './upgrade.vue';
import Upsell from './upsell.vue';
import { computedPbxBasePlans } from '@/common/service/computers/plans/pbx';
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['boughtPlans', 'migratePlanState', 'basicConfig']),
    hasBoughtPbxBasePlan(){
      return !!computedPbxBasePlans(this.boughtPlans).length;
    },
  },
  render() {
    const context = { ...{ props: { ...this.$attrs }, on: { ...this.$listeners } } };
    if (
      this.$context.is.biz2bundle ||
      this.$context.is.pro2bundle ||
      this.migratePlanState.is.upgrade
    ) return <Upgrade {...context} />;
    if (this.$context.is.modalDelta) return <EditDelta {...context} />;
    if (this.$context.is.edit) return <Edit {...context} />;
    if (this.$context.is.add2cart) {
      if (this.basicConfig?.isBulkLicenseAccount) return <Add {...context} />;
      if (this.hasBoughtPbxBasePlan) return <Edit {...context} />;
      return <Add {...context} />;
    }
    if (this.$context.is.buyNow || this.$context.is.basic2pro) return <BuyNow {...context} />;
    if (this.$context.is.upsell) return <Upsell {...context} />;
    return null;
  },
};
</script>
